import { useState, useEffect, useCallback } from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { closestCenter, DndContext } from '@dnd-kit/core'
import { MdDragHandle } from 'react-icons/md'
import { SortableItem } from './SortableItem'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'

const SortableList = ({
    items,
    setItems,
    hasCheckbox = false,
}) => {
    
    const [loading, setLoading] = useState(true)
    
    const reorder = useCallback((list, startIndex, endIndex) => {
        
        if (!list.length) return list
        
        const result = Array.from(list)
        const [removed] = result.splice(startIndex, 1)
        
        result.splice(endIndex, 0, removed)
        
        return result
        
    }, [])
    
    const onDragEnd = ({ active, over }) => {
        
        if (!over) return
        
        const activeIdx = active.data.current.sortable.index
        const overIdx = over.data.current.sortable.index
        
        setItems(prev => reorder(
            prev,
            activeIdx,
            overIdx,
        ))
        
    }
    
    const onItemCheck = (item, checked) => {
        item.checked = checked
        setItems([...items])
    }
    
    const renderField = (item, listener = {}, attributes = {}) => (
        <div className="bg-base-100 rounded mb-2 flex items-center content-center justify-between
            w-full p-[0.85rem] mb-0">
            {hasCheckbox && (
                <input className="checkbox checkbox-sm" type="checkbox" checked={item.checked || false}
                    onChange={event => onItemCheck(item, event.target.checked)} />
            )}
            <div>
                <p>{item.label}</p>
                <p className="text-sm opacity-60">{item.field}</p>
            </div>
            <div className="flex justify-center items-center h-[32px] -my-2 px-2 cursor-grab active:cursor-grabbing
                rounded bg-base-200"
            {...listener} {...attributes} >
                <MdDragHandle className="text-xl active:outline-none"/>
            </div>
        </div>
    )
    
    useEffect(() => {
        
        setLoading(false)
        
    }, [])
    
    if (loading) return null
    if (!items?.length) return null
    
    return (
        <DndContext
            modifiers={[restrictToVerticalAxis]}
            collisionDetection={closestCenter}
            onDragEnd={onDragEnd}>
            <SortableContext items={items}
                strategy={verticalListSortingStrategy}>
                
                {items.map(it => (
                    <SortableItem
                        key={it.id}
                        id={it.id}
                        handle={true}
                        item={it}
                        renderItem={renderField} />
                ))}
            </SortableContext>
        </DndContext>
        
    )
    
}

export default SortableList
